import * as React from "react";

import PendingIcon from "@mui/icons-material/Pending";
import { SvgIconProps } from "@mui/material/SvgIcon";

import type { ActivityAchievementId } from "@volley/data";

import Achievement10Icon from "./Achievement10Icon";
import Achievement11Icon from "./Achievement11Icon";
import Achievement12Icon from "./Achievement12Icon";
import Achievement13Icon from "./Achievement13Icon";
import Achievement14Icon from "./Achievement14Icon";
import Achievement1Icon from "./Achievement1Icon";
import Achievement2Icon from "./Achievement2Icon";
import Achievement3Icon from "./Achievement3Icon";
import Achievement4Icon from "./Achievement4Icon";
import Achievement5Icon from "./Achievement5Icon";
import Achievement6Icon from "./Achievement6Icon";
import Achievement7Icon from "./Achievement7Icon";
import Achievement8Icon from "./Achievement8Icon";
import Achievement9Icon from "./Achievement9Icon";

type Props = SvgIconProps & {
    achievementId: ActivityAchievementId | null;
};

const StatsAchievementIcon: React.FC<Props> = ({
    achievementId,
    ...props
}: Props) => {
    if (!achievementId) return <PendingIcon {...props} />;

    switch (achievementId) {
        case 1:
            return <Achievement1Icon {...props} />;
        case 2:
            return <Achievement2Icon {...props} />;
        case 3:
            return <Achievement3Icon {...props} />;
        case 4:
            return <Achievement4Icon {...props} />;
        case 5:
            return <Achievement5Icon {...props} />;
        case 6:
            return <Achievement6Icon {...props} />;
        case 7:
            return <Achievement7Icon {...props} />;
        case 8:
            return <Achievement8Icon {...props} />;
        case 9:
            return <Achievement9Icon {...props} />;
        case 10:
            return <Achievement10Icon {...props} />;
        case 11:
            return <Achievement11Icon {...props} />;
        case 12:
            return <Achievement12Icon {...props} />;
        case 13:
            return <Achievement13Icon {...props} />;
        case 14:
            return <Achievement14Icon {...props} />;
        default:
            return null;
    }
};

export default StatsAchievementIcon;
